<template>
  <ResourceDialog
    @close="emit('close')"
    @save="handleSave"
    ref="dialogRef"
    :max-width="640"
    :save-button-disabled="!expiresAt"
    cancel-button-text="Cancel"
    save-button-text="Save"
    title="Update expiry date"
    closeable
  >
    <template #form>
      <v-row dense>
        <LabeledDatePicker
          v-model="expiresAt"
          cols="12"
          message="Expiry date"
        />
      </v-row>
    </template>
  </ResourceDialog>
</template>

<script setup>
import LabeledDatePicker from '@/shared/components/form/LabeledDatePicker.vue';
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';

const props = defineProps({
  initialExpiresAt: {
    type: String,
    default: null,
  },
  openOnMount: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close', 'save']);

const dialogRef = ref(null);
const expiresAt = ref(props.initialExpiresAt);

onMounted(load);

async function load() {
  if (!props.openOnMount) return;

  await nextTick();
  open(props.initialExpiresAt);
}

function open(expiryDate = null) {
  expiresAt.value = expiryDate;
  dialogRef.value?.open({ expires_at: expiryDate });
}

function handleSave() {
  emit('save', expiresAt.value);
}

defineExpose({ close: () => dialogRef.value?.close(), open });
</script>
